"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardanoNotEnoughFunds = exports.CardanoMinAmountError = void 0;
const errors_1 = require("@ledgerhq/errors");
/**
 * Cardano error thrown when transaction amount is less then minUtxo
 */
exports.CardanoMinAmountError = (0, errors_1.createCustomErrorClass)("CardanoMinAmountError");
/**
 * Cardano error thrown when not enough funds to perform transaction
 */
exports.CardanoNotEnoughFunds = (0, errors_1.createCustomErrorClass)("CardanoNotEnoughFunds");
//# sourceMappingURL=errors.js.map